export default __webpack_public_path__ + "69fd09a.png";